export default "__VITE_ASSET__916hOE_X__"